import { de as dfns_deDE, deAT as dfns_deAT, enUS as dfns_enUS, enGB as dfns_enGB } from 'date-fns/locale'
import i18n from 'i18next'

import { merge } from '@/utils/misc'

const dateFnsLocales = {
    en: dfns_enGB,
    de: dfns_deDE,
    'de-DE': dfns_deDE,
    'de-AT': dfns_deAT,
    'en-GB': dfns_enGB,
    'en-US': dfns_enUS,
}

type DateFnsLocalesTypeKeys = keyof typeof dateFnsLocales

function isValidDateFnsLocale(locale: string): locale is DateFnsLocalesTypeKeys {
    return locale in dateFnsLocales
}

export const getDateFnsLocale = (locale: DateFnsLocalesTypeKeys | string | null = null) => {
    locale = locale || i18n.language

    if (isValidDateFnsLocale(locale)) {
        return dateFnsLocales[locale]
    }

    const [language] = locale.split('-')

    if (isValidDateFnsLocale(language)) {
        return dateFnsLocales[language]
    }

    // should never come here
    throw new Error(`Unable to handle locale ${locale} for date-fns`)
}

type UnionToIntersection<U> = (U extends any ? (x: U) => void : never) extends (x: infer I) => void ? I : never

export const mergeResources = <
    TLanguage extends Record<string, object>,
    TLanguages extends Array<Record<string, object>>,
>(
    languages: TLanguage,
    otherLanguages: TLanguages
) =>
    Object.keys(languages).reduce(
        (res, language: string) => ({
            ...res,
            [language]: merge.all([
                ...otherLanguages.map((otherLanguage) => otherLanguage[language]),
                languages[language],
            ]),
        }),
        {}
    ) as TLanguage & UnionToIntersection<TLanguages[number]>
